import { erpApi } from "@/shared/axios";
import { useMutation, useQuery, UseQueryOptions } from "@tanstack/react-query";
import { urlBackend } from '@/shared/constants/networking.constants';
import { getUrlParamsFetch } from "@/shared";
import { ReporteAgendamiento, ReporteAgendamientosPylFilter } from "../shared/interface/reports-module.interface";

const { post, get } = erpApi();

const BASE_URL_REPORTS = `${urlBackend}api/v1/reports/`;

/**
 * Hook mutation para obtener la orden de trabajo
 */
export const useFetchReporteAgendamiento = (params: ReporteAgendamientosPylFilter, options?: Omit<UseQueryOptions<any, Error, any>, 'queryKey' | 'queryFn'>) => {
    return useQuery({
        queryKey: ['reporte-agendamiento', params],
        queryFn: async () => {
            return await useGetReporteAgendamiento(params)
        },
        refetchOnWindowFocus: false,
        ...options,
    })
};

export const useGetReporteAgendamiento = async (params?: ReporteAgendamientosPylFilter) => {
    const queryParams = getUrlParamsFetch(params || {});
    const resp = await get<ReporteAgendamiento>(
        `${BASE_URL_REPORTS}preagendamiento?${queryParams}`,
        true
    );
    return resp;
};

// nuevos

export const useObtenerReporteAgendamiento = () => {
  return useMutation({
    mutationFn: async (params: any) => {
      const resp = await post<any[]>(
        `${BASE_URL_REPORTS}preagendamiento`,
        params,
        true
      );
      return resp;
    },
  });
};